// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"CFyWn","inputWrapperText":"DV5VD","inputWrapperDate":"dknIB","inputWrapperBoolean":"UMbFt","inputWrapperNumber":"EfCiH","inputWrapperDropdown":"ZVbIl"};